/**
 * @author chargoyao
 *
 * UpdateAdminUserTip Component
 *
 * @props UpdateAdminUserTipDialogOpen {boolean} if open tip.
 * @props closeUpdateAdminUserTipDialog {function} when user click `close` button function.
 * @props continue {function} when user click the `confirmation` button go ahead to do something.
 * @props continueLabel {string} confirmation button label string.
 * @props children {node} the node which you want to append.
 *
 */

import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import ClientUsers from "./ClientUsers";
// confirmation
import { buttonBlueColor } from "../../utils/utility";

import "./employees.css";

class Employees extends Component {
  constructor(props) {
    super(props);
    this.throttle = true;
    this.state = {
      open: false,
      value: "", // for table list dialog role value
      rolesValue: "", // role value for invite component
      openInviteUser: false,
      requestParams: {
        pageNumber: 1,
        pageSize: 10,
        sortColumn: "name", //support name , role, email, status field
        order: "desc", // asc or desc
      },
      employeeName: "", // name of employee
      suspendUserDialogOpen: false, // if open the dialog of suspend user success ui
      ifReassignClientUIDispaly: false, // weather display re-assign client.
      ifDisplayConfirmation: false,
      ifDisplayUpdateAdminUser: true, // default display update admin user view
      archiveUserDialogOpen: false, // open the dialog, when click `Archive User`
      ifArchiveOverlayDisplay: false, // archive overlay
      ifDisplayArchiveUserLink: false, // if archive link click
      updateParams: {
        firstName: "",
        lastName: "",
        email: "",
        roleId: 1,
      },
      employeeId: "",
      ifUpdateButtonDisable: true,
    };
  }
  componentDidMount() {
    if (this.props.roleId === 5)
      //operation manager
      this.props.history.push("/");
    // get role data
    const params = {
      pageNumber: 1,
      pageSize: 10,
      sortColumn: "name", //support name , role, email, status field
      order: "desc", // asc or desc
    };
    if (this.props.roleId > 50) {
      this.props.getClientRoles();
      this.props.getTableList(params, this.props.selected_client);
    } else if (this.props.roleId > 0) {
      this.props.getRoles();
      this.props.getTableList(params);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.roleId === 5) this.props.history.push("/");
    if (nextProps.updateErrorText === "") {
      this.setState({
        open: false,
      });
    }
    const params = {
      pageNumber: 1,
      pageSize: 10,
      sortColumn: "name", //support name , role, email, status field
      order: "desc", // asc or desc
    };

    if (nextProps.roleId !== this.props.roleId) {
      if (nextProps.roleId > 50) {
        this.props.getClientRoles();
        if (nextProps.selected_client > 0)
          this.props.getTableList(params, nextProps.selected_client);
      } else if (nextProps.roleId > 0) {
        this.props.getRoles();
        this.props.getTableList(params);
      }
    }

    if (nextProps.selected_client !== this.props.selected_client) {
      if (nextProps.roleId > 50) {
        if (nextProps.selected_client > 0)
          this.props.getTableList(params, nextProps.selected_client);
      } else if (nextProps.roleId > 0) {
        this.props.getTableList(params);
      }
    }
  }
  handleDialogShow(e, employeeName) {
    this.props.history.push(
      `/employees/user-status/${employeeName.id}/${
        this.state.requestParams.pageNumber
      }/${this.state.requestParams.sortColumn}/${
        this.state.requestParams.order
      }`,
    );
  }

  // below is callback for page component
  nextBeClick(page) {
    this.dispatchPageAction(page);
  }
  nextGroupBeClick(page) {
    this.dispatchPageAction(page);
  }
  previousGroupBeClick(page) {
    this.dispatchPageAction(page);
  }
  previousBeClick(page) {
    this.dispatchPageAction(page);
  }
  pageBeClick(page) {
    this.dispatchPageAction(page);
  }
  goToPage(page) {
    if (page > this.props.tableList.pageCount) {
      return;
    } else {
      this.dispatchPageAction(page);
    }
  }

  handleIconClick(targetName) {
    const params = {
      order: this.state.requestParams.order === "desc" ? "asc" : "desc",
      sortColumn: "name",
    };

    switch (targetName) {
      case "Role":
        params.sortColumn = "role";
        break;
      case "Email":
        params.sortColumn = "email";
        break;
      case "Status":
        params.sortColumn = "status";
        break;
      case "Name":
        params.sortColumn = "name";
        break;
      default:
        return;
    }
    this.setState({
      requestParams: {
        order: params.order,
        sortColumn: params.sortColumn,
      },
    });
    this.props.roleId > 50
      ? this.props.getTableList(params, this.props.selected_client)
      : this.props.getTableList(params);
  }
  render() {
    const muiTheme = getMuiTheme({
      menuItem: {
        hoverColor: buttonBlueColor(),
      },
    });
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="employees">
          {/*<section className="users">*/}
          {/*<img src="" alt="LOGO" className="user-img" />*/}
          {/*<span>Hello, Jim</span>*/}
          {/*</section>*/}
          {/*<h3>INTERNAL USERS</h3>*/}
          <ClientUsers {...this.props} />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Employees;



// WEBPACK FOOTER //
// ./src/components/Employees/Index.jsx